import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Container,
  IconButton,
  Menu,
  MenuItem,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link as RouterLink, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    { text: 'Produits', path: '/agents' },
    // { text: 'Tarifs', path: '/pricing' },
    // { text: 'Ressources', path: '/resources' },
    // { text: 'Cas clients', path: '/case-studies' },
  ];

  const buttonStyle = {
    color: isHomePage ? '#ffffff' : '#000000',
    textTransform: 'none',
    fontFamily: 'GT Walsheim Pro, sans-serif',
    fontWeight: 400,
    fontSize: '16px',
    transition: 'opacity 0.2s ease',
    '&:hover': {
      backgroundColor: 'transparent',
      opacity: 0.7,
    },
    '&:focus': {
      backgroundColor: 'transparent',
      outline: 'none',
    },
    '&.MuiButton-root': {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  };

  const menuItemStyle = {
    color: isHomePage ? '#ffffff' : '#000000',
    fontFamily: 'GT Walsheim Pro, sans-serif',
    '&:hover': {
      opacity: 0.7,
      backgroundColor: 'transparent',
    },
    '&:focus': {
      backgroundColor: 'transparent',
    },
  };

  return (
    <AppBar 
      position="absolute" 
      sx={{ 
        backgroundColor: isHomePage ? 'transparent' : 'rgba(250, 248, 245, 0.95)',
        backdropFilter: isHomePage ? 'none' : 'blur(8px)',
        boxShadow: 'none',
        borderBottom: isHomePage ? 'none' : '1px solid rgba(0, 0, 0, 0.1)',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar 
          disableGutters 
          sx={{ 
            minHeight: { xs: '64px', md: '68px' },
            justifyContent: 'space-between',
          }}
        >
          <RouterLink to="/" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
            <Box
              component="img"
              src="/logo_4.png"
              alt="Famber Logo"
              sx={{ 
                height: { xs: 10, md: 30 },
                mr: 1,
              }}
            />
            <Box
              component="span"
              sx={{
                fontFamily: 'GT Walsheim Pro, sans-serif',
                fontSize: { xs: '16px', md: '20px' },
                fontWeight: 600,
                color: isHomePage ? '#ffffff' : '#000000',
              }}
            >
              Famber
            </Box>
          </RouterLink>

          {isMobile ? (
            <>
              <IconButton
                size="large"
                edge="start"
                aria-label="menu"
                onClick={handleMenu}
                sx={{ 
                  color: isHomePage ? '#ffffff' : '#000000',
                  '&:focus': {
                    outline: 'none',
                  },
                }}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                PaperProps={{
                  sx: {
                    backgroundColor: isHomePage ? 'rgba(0, 0, 0, 0.9)' : 'rgba(247, 245, 250, 0.95)',
                    backdropFilter: 'blur(8px)',
                    border: '1px solid rgba(0, 0, 0, 0.1)',
                  }
                }}
              >
                {menuItems.map((item) => (
                  <MenuItem
                    key={item.text}
                    component={RouterLink}
                    to={item.path}
                    onClick={handleClose}
                    sx={menuItemStyle}
                  >
                    {item.text}
                  </MenuItem>
                ))}
                <MenuItem
                  component="a"
                  href="https://calendly.com/fambercontact/30min"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={menuItemStyle}
                >
                  Prendre rendez-vous
                </MenuItem>
                {/* <MenuItem
                  component={RouterLink}
                  to="/login"
                  sx={menuItemStyle}
                >
                  Connexion
                </MenuItem> */}
                <MenuItem
                  component="a"
                  href="https://tally.so/r/mJWEgJ"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={menuItemStyle}
                >
                  Essai gratuit
                </MenuItem>
              </Menu>
            </>
          ) : (
            <>
              <Box sx={{ display: 'flex', gap: 2, flexGrow: 1, ml: 4 }}>
                {menuItems.map((item) => (
                  <Button
                    key={item.text}
                    component={RouterLink}
                    to={item.path}
                    sx={buttonStyle}
                    disableRipple
                  >
                    {item.text}
                  </Button>
                ))}
              </Box>
              <Box sx={{ display: 'flex', gap: 3 }}>
                <Button
                  component="a"
                  href="https://calendly.com/fambercontact/30min"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={buttonStyle}
                  disableRipple
                >
                  Prendre rendez-vous
                </Button>
                <Button
                  component="a"
                  href="https://tally.so/r/mJWEgJ"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    ...buttonStyle,
                    backgroundColor: '#8B5CF6 !important',
                    color: '#ffffff',
                    px: 3,
                    '&:hover': {
                      backgroundColor: '#7C3AED !important',
                    },
                    '&:focus': {
                      backgroundColor: '#8B5CF6 !important',
                      outline: 'none',
                    },
                  }}
                  disableRipple
                >
                  Essai gratuit
                </Button>
              </Box>
            </>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar; 